import { User } from "oidc-client-ts";

import { oidcConfig } from "./oidcConfig";

export const getUserInfo = (): User | null => {
    const storageKey = `oidc.user:${oidcConfig.authority}:${oidcConfig.client_id}`;
    const oidcStorage = globalThis.localStorage.getItem(storageKey) ?? globalThis.sessionStorage.getItem(storageKey);
    if (!oidcStorage) {
        return null;
    }

    return User.fromStorageString(oidcStorage);
};

export const onSigninCallback = (user: User | void) => {
    globalThis.history.replaceState({}, document.title, globalThis.location.pathname);
    // @ts-ignore
    globalThis.location = user.state || "/";
};
